import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Notice {
  id: number
  text: string
  color: 'success' | 'error' | 'info' | 'warning'
  timeout: number
}

/** Transient toasts for background actions (copy, save, state changes). */
export const useNotifyStore = defineStore('notify', () => {
  const current = ref<Notice | null>(null)
  let nextId = 1

  function show(text: string, color: Notice['color'] = 'info', timeout = 3500) {
    current.value = { id: nextId++, text, color, timeout }
  }

  return {
    current,
    show,
    success: (text: string) => show(text, 'success'),
    error: (text: string) => show(text, 'error', 6000),
    info: (text: string) => show(text, 'info'),
    clear: () => (current.value = null),
  }
})
